// extracted by mini-css-extract-plugin
export default {"arrow_prev":"SliderButton_arrow_prev__Ah2S6","arrow_next":"SliderButton_arrow_next__eKGLD"};